import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "./AdminMenu";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import Button from "../../components/elements/Button";
import InputField from "../../components/elements/InputField";
import {ADMIN_API_BASE} from "../../utils/apiConfig";
import {faAdd, faBook, faSave, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const AdminLanguages = () => {
    const [languages, setLanguages] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchLanguages();
    }, []);

    const fetchLanguages = async () => {
        try {
            const token = await getCsrfToken();
            const res = await axios.get(`${ADMIN_API_BASE}/language`,
                {
                    headers: {'csrf-token': token},
                    withCredentials: true
                }
            );
            if (res.data.success) {
                setLanguages(res.data.languages.languages);
            } else {
                setError(res.data.error);
            }
        } catch (e) {
            setError(e);
        }
    };

    const handleAddButtonClick = () => {
        setLanguages([...languages, {id: "", abbr: "", text: "", type: "new"}]);
    };

    const handleChange = (index, e) => {
        const {name, value} = e.target;

        const updated = [...languages];
        updated[index][name] = value;

        setLanguages(updated);
    };

    const handleSaveButtonClick = async (language) => {
        try {
            const token = await getCsrfToken();
            if (language.type !== "new") {
                const res = await axios.put(
                    `${ADMIN_API_BASE}/language/`,
                    {id: language.id, text: language.text, abbr: language.abbr},
                    {
                        headers: {
                            'csrf-token': token,
                        },
                        withCredentials: true
                    }
                );
            } else {
                await axios.post(
                    `${ADMIN_API_BASE}/language`,
                    {id: language.id, text: language.text, abbr: language.abbr},
                    {
                        headers: {
                            'csrf-token': token,
                        },
                        withCredentials: true
                    }
                );
            }

            fetchLanguages();
        } catch (e) {
            console.log(e);
        }
    };

    const handleDelete = async (id) => {
        try {
            const token = await getCsrfToken();

            await axios.delete(`${ADMIN_API_BASE}/language/${id}`, {
                headers: {
                    'csrf-token': token,
                },
                withCredentials: true
            });

            fetchLanguages();
        } catch (e) {
            console.log(e);
        }
    };

    const getCsrfToken = async () => {
        const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include", // critical to send the session cookie
        });

        const data = await response.json();
        return data.csrfToken;
    };

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        <AdminHeader title='زبان‌ها'/>
                        <div className='w-full flex flex-col px-10 flex-1 my-10'>
                            <Button onClick={handleAddButtonClick}>
                                <FontAwesomeIcon icon={faAdd} className="mr-2"/>
                                <span>اضافه‌کردن زبان</span>
                            </Button>
                            <div className="w-full flex flex-col gap-3 px-10 rounded-lg bg-gray-200 mt-10">
                                {languages.map((lang, index) => (
                                    <div key={index} className="flex gap-3 items-center">

                                        <InputField
                                            value={lang.id}
                                            title={'زبان'}
                                            name="id"
                                            type="text"
                                            onChange={(e) => handleChange(index, e)}
                                            className="w-1/4"
                                        />

                                        <InputField
                                            value={lang.text}
                                            title={'مقدار'}
                                            name="text"
                                            type="text"
                                            onChange={(e) => handleChange(index, e)}
                                            className="w-1/4"
                                        />

                                        <InputField
                                            value={lang.abbr}
                                            title={'مخفف'}
                                            name="abbr"
                                            type="text"
                                            onChange={(e) => handleChange(index, e)}
                                            className="w-1/4"
                                        />

                                        <Button onClick={() => handleSaveButtonClick(lang)}>
                                            <FontAwesomeIcon icon={faSave} size={"xl"}/>
                                        </Button>

                                        <Button onClick={() => handleDelete(lang.id)}>
                                            <FontAwesomeIcon icon={faTrashCan} size={"xl"}/>
                                        </Button>

                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminLanguages;
